module.exports = __webpack_public_path__ + "img/inbox_g.2d0a9c37.svg";